// `VITE_API_URL` already carries the `/api/benef` prefix (see planApiPath.ts).
const PURCHASE_POINTS_API_BASE_URL = "/purchase_points/offers";
const PURCHASE_POINTS_BRANDS_API_URL = "/purchase_points/brands";
const PURCHASE_POINTS_HIGHLIGHTED_OFFERS_API_URL = "/purchase_points/highlighted_offers";
const PURCHASE_POINTS_BALANCE_API_URL = "/purchase_points/balance";
const PURCHASE_POINTS_REWARDS_API_URL = "/purchase_points/rewards";
const PURCHASE_POINTS_CONVERSIONS_API_URL = "/purchase_points/conversions";

export const PURCHASE_POINTS_API_ENDPOINTS = {
  GET_OFFER: (offerId: string) => `${PURCHASE_POINTS_API_BASE_URL}/${encodeURIComponent(offerId)}`,
  GET_BRANDS: PURCHASE_POINTS_BRANDS_API_URL,
  GET_BRAND: (brandSlug: string) => `${PURCHASE_POINTS_BRANDS_API_URL}/${encodeURIComponent(brandSlug)}`,
  GET_HIGHLIGHTED_OFFERS: PURCHASE_POINTS_HIGHLIGHTED_OFFERS_API_URL,
  GET_BALANCE: PURCHASE_POINTS_BALANCE_API_URL,
  GET_REWARDS: PURCHASE_POINTS_REWARDS_API_URL,
  GET_CONVERSIONS: PURCHASE_POINTS_CONVERSIONS_API_URL,
  CREATE_CONVERSION: PURCHASE_POINTS_CONVERSIONS_API_URL,
} as const;
